import { Component, inject, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { StripeServiceAngular } from '../../service/stripe.service';
import { environment } from '../../../../environments/environment.development';
import { StripeElementsOptions, PaymentIntent, StripeCardElementOptions, PaymentMethodCreateParams, CreatePaymentMethodCustomerBalanceData, CreatePaymentMethodData } from '@stripe/stripe-js';
import { StripeService, StripePaymentElementComponent, injectStripe, StripeCardComponent, StripeCardNumberComponent, NgxStripeModule } from 'ngx-stripe';
import { EnviaService } from '../../service/envia.service';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons';
import { faStripe } from '@fortawesome/free-brands-svg-icons';
import { NgxNotifier, NgxNotifierService } from 'ngx-notifier';

@Component({
  selector: 'app-stripe-setup-intents',
  imports: [ReactiveFormsModule, NgxStripeModule, FontAwesomeModule],
  templateUrl: './stripe-setup-intents.component.html',
  styleUrl: './stripe-setup-intents.component.scss',
  standalone: true
})
export class StripeSetupIntentsComponent {
  private readonly gaService = inject(GoogleAnalyticsService);
  @ViewChild(StripeCardNumberComponent) card!: StripeCardNumberComponent;
  @Input() item: any;
  iconSpinner = faSpinner;
  iconStripe = faStripe;
  stripe = injectStripe(environment.stripe.token);
  listCountries: any = [];
  successLottery = true;
  loading = false;
  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        // backgroundColor:'white',
        padding: '10px 5px 10px 5px',
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#31325F',
        },
      },
      invalid: {
        iconColor: '#ffc7ee',
        color: '#f01e21',
      },
    },
  };
  elementsOptions: StripeElementsOptions = {
    locale: 'es',
    currency: 'mxn',
  };

  setup: FormGroup;
  validateTerms: FormGroup;
  constructor(
    private fb: FormBuilder,
    private stripeService: StripeService,
    private stService: StripeServiceAngular,
    private enviaServices: EnviaService,
    private ngxNotifierService: NgxNotifierService
  ) {
    this.setup = this.fb.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      country: [''],
      ig: ['', [Validators.required]],
    });

    this.validateTerms = this.fb.group({
      terms: ['', [Validators.required]],
    });

    this.enviaServices.getCountries().subscribe((res) => {
      this.listCountries = res.data;
    });
  }

  createToken() {
    
    if (this.validateTerms.invalid) {
      this.validateTerms.get('terms')?.setValue(false);
      return false;
    }
    if (this.setup.invalid) {
      this.setup.markAllAsTouched();
      return false;
    }
    this.validateTerms.get('terms')?.setValue(true);
    this.proccessSetupItents();
    this.loading = true;
    // Swal.fire({
    //   icon: 'question',
    //   text: 'By accepting, you agree to our terms and conditions.',
    //   showCancelButton: true,
    //   showConfirmButton: true,
    //   confirmButtonText: 'Accept',
    //   cancelButtonText: 'Cancel',
    //   cancelButtonColor: "#d33",
    // }).then(res => {
    //   if (res.isConfirmed) {
    //     this.proccessSetupItents();
    //     this.loading = true;
    //   }
    // });
    return true;

  }

  createSetupIntent(pm) {
    let currency: any;
    this.item.price_currency.forEach(element => {
      if (element.currency === 'MXN') {
        currency = +element.regular_price;

        if (Number.isInteger(currency)) {
          currency = currency.toString() + '00';
        } else {
          const split = currency.toString().split('.');
          let decimal = '';

          if (split[1].length === 1) {
            decimal = `0${split[1]}`;
          } else {
            decimal = split[1];
          }

          currency = `${split[0]}${decimal}`;
        }

      }
    });
    const obj = {
      email: this.setup.get('email')?.value,
      first_name: this.setup.get('first_name')?.value,
      last_name: this.setup.get('last_name')?.value,
      ig: this.setup.get('ig')?.value,
      payment_method: pm,
      id_product: this.item.id_firebase,
      price: currency
    };

    this.stService.postSetupIntents(obj).subscribe((res) => {
      if (res.success) {
        this.successLottery = false;

        this.gaService.event('Lottery', {
          'label': `Lottery Success Register ${obj.email}`
        });
        // Swal.fire({
        //   icon: 'success',
        //   html: '<h4>¡Thank you for entering the raffle! <br>Your registration has been received</h4><p>We will contact you if you win.</p>',
        //   confirmButtonText: '¡Good Luck!',
        // });
      }

    }, erro => {
      this.loading = false;
      this.gaService.event('Lottery', {
        'label': `Lottery Error Register ${obj.email}`
      });

      if (erro.error.message) {
        this.successLottery = true;
        // Swal.fire({
        //   icon: 'error',
        //   text: `${erro.error.message}`,
        // });

        this.ngxNotifierService.createToast(`${erro.error.message}`, 'danger', 1000);
      } else {
        // Swal.fire({
        //   icon: 'error',
        //   text: 'An unexpected error occurred. Please try again. ',
        // });

        this.ngxNotifierService.createToast('An unexpected error occurred. Please try again. ', 'danger', 1000);
      }

    });


  }
  proccessSetupItents() {
    const name = `${this.setup.get('first_name')?.value} ${this.setup.get('last_name')?.value}`;
    const user = {
      name: name,
      email: this.setup.get('email')?.value,
      country: this.setup.get('country')?.value,
      ig: this.setup.get('ig')?.value,
      conditions: true,
    };
    // console.log(this.setup.value);
    // return false;
    this.stripe.createToken(this.card.element, user).subscribe((result) => {
      if (result.token) {

        const methodPayment: CreatePaymentMethodData = {
          type: 'card',
          card: {
            token: result?.token?.id!,
          },
        };
        this.stripe.createPaymentMethod(methodPayment).subscribe((res) => {

          const _pm = res?.paymentMethod?.id!;
          this.createSetupIntent(_pm);
        });
      } else if (result.error) {
        this.loading = false;
        // Swal.fire({
        //   icon: 'error',
        //   text: `${result.error}`,
        // });
        this.ngxNotifierService.createToast(`${result.error}`, 'danger', 1000);

      }
    });
  }
}
